import { render, staticRenderFns } from "./CostBearerPracticalExamDetails.vue?vue&type=template&id=55828ebb&"
import script from "./CostBearerPracticalExamDetails.vue?vue&type=script&lang=ts&"
export * from "./CostBearerPracticalExamDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports